<template>
  <div class="attachment">
    <div v-if="fields.length > 0" class="form-group">
      <label class="form-control-label">Workflow Grids Status Field:</label>
      <select @input="updateStatusField($event.target.value)" :value="fields[0].label" class="form-control form-control-sm">
        <option v-for="field in fields" :key="field.id">{{ field.label }}</option>        
      </select>
    </div>
  </div>
</template>

<script>
import { formBase } from './mixins'

export default {
  mixins: [formBase],
  computed: {
    fields: function() {
      var fieldTree = []
      var f = this.dataGrid_options

      Object.keys(f).forEach(function(key) {
        var fieldsKey = f[key].meta
        var name = f[key].title

        var objectFields = []
        Object.keys(fieldsKey).forEach(function(k) {
          if (fieldsKey[k].type == 'lookup'){
            var label = name +  ' / ' + fieldsKey[k].displayName
            var id = key +  '.' + k + '.' + fieldsKey[k].lookUpTable
            objectFields.push({id,label})
          }
        });
        fieldTree.push.apply(fieldTree, objectFields)
      });
      return fieldTree
    },
  },
  methods: {
    updateStatusField(value) {
      this.updateMetaData({
        statusField: value
      })
    }
  }
}
</script>

<style>

</style>